import Typography from '@mui/material/Typography';
import { BarChart, BarChartProps } from '@mui/x-charts/BarChart';
import React, { useState, useEffect, useCallback } from "react";
import allTeams from "../../data/teams"; // Adjust the import path as necessary
import { Link } from "react-router-dom";
import apiUrl from "../../config";
import { Details } from '@mui/icons-material';

const translations = {
  shot_on_goal:       'Saved shot',
  goal:               'Goal',
  assist:            'Assist',
  blocked_shot:       'Blocked shot',
  takeaway:           'Takeaway',
  faceoff:            'Faceoff win',
  faceoffloss:            'Faceoff loss',
  giveaway:           'Giveaway',
  hit:                'Hit',
  block:              'Block',
  missed_shot:        'Missed shot',
  penalty:           'Penalty',
  hit_receid:        'Hit received',
  goalagainst:      'Goal against',
};

// { dataKey: 'goal', stack: 'shots', fill: '#00cc66', name: 'Goals', barWidth: 15 },
// { dataKey: 'shot-on-goal', stack: 'shots', fill: '#66ccff', name: 'Shots on Goal', barWidth: 15 },
// { dataKey: 'missed-shot', stack: 'shots', fill: '#ffaa00', name: 'Missed Shots', barWidth: 15 },
// { dataKey: 'blocked-shot', stack: 'shots', fill: '#cccccc', name: 'Blocked Shots', barWidth: 15 },

// // Physical Plays
// { dataKey: 'hit', stack: 'physical', fill: '#e60000', name: 'Hits', barWidth: 15 },
// { dataKey: 'penalty', stack: 'physical', fill: '#800000', name: 'Penalties', barWidth: 15 },

// // Puck Possession/Turnovers
// { dataKey: 'faceoff', stack: 'possession', fill: '#8080ff', name: 'Faceoffs', barWidth: 15 },
// { dataKey: 'takeaway', stack: 'possession', fill: '#008040', name: 'Takeaways', barWidth: 15 },
// { dataKey: 'giveaway', stack: 'possession', fill: '#ff6666', name: 'Giveaways', barWidth: 15 },


function addLabels<T extends { dataKey: keyof typeof translations }>(series: T[]) {
    return series.map((item) => ({
      ...item,
      label: translations[item.dataKey],
    }));
  }

const playerIdKeys = [
  'scoringPlayerId',
  'assist1PlayerId',
  'assist2PlayerId',
  'shootingPlayerId',
  'hitterPlayerId',
  'hitteePlayerId',
  'penaltyPlayerId',
  'committedByPlayerId',
  'drawnByPlayerId',      // pour les giveaways, turnovers, etc.
  'playerId',             // key générique — dans certains events simples…
  'goalieInvolvedId',     // pour les arrêts, buts, ou conséquences sur le gardien
  'blockerPlayerId',      // pour les blocks (tir, passe, etc.)
  'blockingPlayerId',     // parfois utilisé à la place de blockerPlayerId
  'playerResponsibleId',  // parfois pour indiquer qui a causé l’action (pénalité, turnover…)
  'winningPlayerId',      // pour des events décisifs, pénalités, etc.
  'losingPlayerId',
  'goalieInNetId',
];

  async function getPlayerPlays(dataGameId, playerId) {
    const groupedPlays = {};
    playerId = Number(playerId);
  
    console.log("Fetching plays for dataGameId:", dataGameId);
    // Initialize all gameIds with empty arrays
    for (const item of dataGameId) {
      groupedPlays[item.id] = [];
    }
  
    for (const item of dataGameId) {
      const gameId = item.id;
      try {
        const res = await fetch(`${apiUrl}/api/game/play-by-play/${gameId}/`);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const data = await res.json();
  
        const playerPlays = data.plays.filter(play =>
          play.details && playerIdKeys.some(key => play.details[key] === playerId)
        );
  
        console.log("playerPlays",playerPlays);


        groupedPlays[gameId] = playerPlays; // Will be [] if no plays found
      } catch (err) {
        console.error(`Error fetching game ${gameId}:`, err);
        // groupedPlays[gameId] remains as []
      }
    }
    console.log("groupedPlays:", groupedPlays);
    return groupedPlays;
  }
  type Play = {
    typeDescKey: string;
    // ...other properties if needed
  };



  export default function GoalieAction({ chartData, playerId }) {
    const [chartDataFinal, setChartDataFinal] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
  
    useEffect(() => {
      async function fetchData() {
        setIsLoading(true);
        const dataGameId = Array.isArray(chartData)
          ? chartData.map(({ id }) => ({ id }))
          : [];
  
        const playByplay = await getPlayerPlays(dataGameId, playerId);

        console.log("playByplay:", playByplay);

        // Type assertion for allPlays
        const allPlays = Object.values(playByplay).flat() as Play[];

        // const gameTypeCounts = Object.entries(playByplay).map(([gameId, plays]) => {
        //   const typeCounts = (plays as Play[]).reduce((acc, play) => {
        //     const key = play.typeDescKey.replace(/-/g, '_');
        //     acc[key] = (acc[key] || 0) + 1;
        //     return acc;
        //   }, {} as Record<string, number>);
        //   return { gameId, typeCounts };
        // });

        const gameTypeCounts = Object.entries(playByplay).map(([gameId, plays], i) => {
          const typeCounts = (plays as Play[]).reduce((acc, play) => {
            const key = play.typeDescKey.replace(/-/g, '_');

            if(play.typeDescKey == "goal" && play["details"].assist1PlayerId == playerId || play["details"].assist2PlayerId == playerId) {
              acc['assist'] = (acc['assist'] || 0) + 1;
            }
            else if(play.typeDescKey == "goal" && play["details"].scoringPlayerId == playerId) {
              acc['goal'] = (acc['goal'] || 0) + 1;
            }
            else if(play.typeDescKey == "goal" && play["details"].goalieInNetId == playerId) {
                acc['goalagainst'] = (acc['goalagainst'] || 0) + 1;
              }
            else if(play.typeDescKey == "penalty" && play["details"].committedByPlayerId == playerId) {
              acc['penalty'] = (acc['penalty'] || 0) + 1;
            }
            else if(play.typeDescKey == "shot-on-goal" && play["details"].goalieInNetId == playerId) {
              acc['shot_on_goal'] = (acc['shot_on_goal'] || 0) + 1;
            }

            else if(play.typeDescKey == "missed-shot" && play["details"].goalieInNetId == playerId) {
              acc['missed_shot'] = (acc['missed_shot'] || 0) + 1;
            }

            else if(play.typeDescKey == "takeaway" && play["details"].playerId == playerId) {
              acc['takeaway'] = (acc['takeaway'] || 0) + 1;
            }

            else if(play.typeDescKey == "takeaway" && play["details"].playerId == playerId) {
              acc['takeaway'] = (acc['takeaway'] || 0) + 1;
            }           

            else {
             // acc[key] = (acc[key] || 0) + 1;
            }
            return acc;
          }, {} as Record<string, number>);
          return { gameNumber: i + 1, ...typeCounts }; // flatten typeCounts
        });

        // const typeCounts = allPlays.reduce((acc, play) => {
        //   const key = play?.typeDescKey;
        //   if (key) acc[key] = (acc[key] || 0) + 1;
        //   return acc;
        // }, {} as Record<string, number>);

        // const finalData = Object.entries(typeCounts).map(([typeDescKey, count]) => ({
        //   typeDescKey,
        //   count,
        // }));
  
        console.log("Final Chart Data:", gameTypeCounts);
        setChartDataFinal(gameTypeCounts);
        setIsLoading(false);
        
      }
  
      fetchData();
    }, [chartData, playerId]);
  
    if (isLoading) {
      return <div>Loading...</div>;
    }    

  return (
    <div className='width100' style={{ padding: '20px'}}>
      <Typography style={{color: 'black', fontWeight: '900'}}>Action chart</Typography>
      <BarChart
      dataset={chartDataFinal}
      series={addLabels([
        { dataKey: 'shot_on_goal', stack: 'good', color: '#0fd500', },
        { dataKey: 'missed_shot', stack: 'good', color: '#087700',},
        { dataKey: 'goalagainst', stack: 'bad', color: '#aa0028',  },
        { dataKey: 'assist', stack: 'good', color: '#0cb000', },
        { dataKey: 'goal', stack: 'good', color: '#0fd500',  },
        { dataKey: 'penalty', stack: 'bad', color: '#680018',},

    ])}
      xAxis={[
        {
          dataKey: 'gameNumber',
          barGapRatio: 0.05,
          categoryGapRatio: 0.15,
        },
      ]}
      {...config}
    />
    </div>
  );
}

const config: Partial<BarChartProps> = {
    height: 350,
    margin: { left: 0 },
    yAxis: [{ width: 35, min: 0 }],
    hideLegend: false,
};